import CardError from './CardError';

export default CardError;
